/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Dashboard_Archived_BannerInputs */

const en_company_dashboard_archived_banner = /** @type {(inputs: Company_Dashboard_Archived_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your company is archived. Job positions are currently hidden from candidates and new applications are blocked. Please contact an administrator to reactivate the company.`)
};

const de_company_dashboard_archived_banner = /** @type {(inputs: Company_Dashboard_Archived_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Unternehmen ist archiviert. Stellen sind für Bewerber:innen aktuell nicht sichtbar und neue Bewerbungen werden blockiert. Bitte wenden Sie sich an einen Administrator, um das Unternehmen zu reaktivieren.`)
};

/**
* | output |
* | --- |
* | "Your company is archived. Job positions are currently hidden from candidates and new applications are blocked. Please contact an administrator to reactivate ..." |
*
* @param {Company_Dashboard_Archived_BannerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_dashboard_archived_banner = /** @type {((inputs?: Company_Dashboard_Archived_BannerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Dashboard_Archived_BannerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_dashboard_archived_banner(inputs)
	return en_company_dashboard_archived_banner(inputs)
});